import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SaleOrderTrackDto } from './sale-order-track.dto';

export class AllSaleOrdersTrackResponseModel extends GlobalResponseObject {
    data?: SaleOrderTrackDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: SaleOrderTrackDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

